import styled from 'styled-components'
import tw from 'tailwind-styled-components'

export const SearchWrap = styled.div`
  margin-bottom: 15px;
`

export const ScrollBarStyled = styled.div`
  scrollbar-color: #292b32 #212226;
  scrollbar-width: thin;
`
export const ListViewWrap = styled(ScrollBarStyled)`
  height: 320px;
  padding-right: 10px;
  overflow: auto;
`

export const CoinListRow = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 10px;
  height: 56px;
  border: 1px solid #2f2f33;
  border-radius: 28px;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 9px;
  background-color: '#f0f8ff';

  border: ${(p) => (p.$isActive ? '2px solid #3ccea2' : '')};

  &:hover {
    background: #26272d;
    border: 1px solid #26272d;
    border: ${(p) => (p.$isActive ? '2px solid #3ccea2' : '1px solid #26272d')};
  }
`

export const CoinImage = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`

export const BalanceWrap = styled.div`
  font-weight: bold;
`

export const CoinText = styled.span`
  margin-left: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`

export const BalanceBlock = styled.span`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;
  color: #ffffff;
`

export const InputLabel = tw.label`
  flex justify-center items-center mb-15
`

export const Input = tw.input`
  mr-5
`